import { Lightning as lng, Log } from '@lightningjs/sdk';
import { listFilterType } from '../listPage/FilterState';
import { EpgGuide } from './EpgGuide';
import { getTime } from '../../../Business/utility/DateFormatter';
import { EpgGuideFilterDataSource } from '../../../Business/epg/guide/EpgGuideFilterDataSource';
import { CmsConstants } from '../../../Business/cms/CmsConstants';

const _constants = {
  marginTopFilters: 20,
  marginTopGuide: 20,
  marginLeftGuide: 162,
  timeBlock: 2,
};

export class EpgGuidePage extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      clipping: true,
      w: w => w,
      h: h => h,
      Content: {
        w: w => w,
        h: h => h,
      },
    };
  }

  _init() {
    Log.info('[EpgGuidePage] _init', this);
    this._backend = this.params.backend;
    //default focusIdx one because the filter is at 0
    this.focusIdx = 1;

    // calculate start and end time based on current time
    const now = new Date();
    this.startTime = new Date(now.setMinutes(0, 0, 0));
    this.endTime = new Date(now.setHours(now.getHours() + _constants.timeBlock));
    Log.info('[EpgGuidePage] init times', getTime(this.startTime), getTime(this.endTime));

    let filtersDS = new EpgGuideFilterDataSource(this._backend);

    // add guide
    const margin = _constants.marginTopFilters + filtersDS.height() + _constants.marginTopGuide;
    this.guide = this.tag('Content').childList.a({
      type: EpgGuide,
      x: _constants.marginLeftGuide,
      y: margin,
      h: h => h - margin,
      w: w => w - _constants.marginLeftGuide,
      backend: this._backend,
    });

    filtersDS.load().then(() => {
      this.tag('Content').childList.addAt(
        {
          y: 20,
          x: CmsConstants.Ribbon.pageContentOffset,
          ...filtersDS.componentDescription(),
        },
        0
      );

      this.currentFilterState = filtersDS.state;
      filtersDS.state.subscribe((type, value) => {
        if (!value && type !== listFilterType.all) return;
        Log.info('[Selected Filters]', type, value);
        if (type === listFilterType.all) {
          // reset
          this.guide.updateTime(this.startTime, this.endTime);
          this.guide.updateCategories([]);
          return;
        }
        if (type === listFilterType.day) {
          const newDay = new Date(value.value);
          newDay.setHours(this.startTime.getHours());
          const newDayEnd = new Date(newDay).setHours(newDay.getHours() + 2);
          this.guide.updateTime(newDay, newDayEnd);
        }
        if (type === listFilterType.tag) {
          this.guide.updateCategories(value.value);
        }
      });
    });

    this.guide.datasource.logPageView(this.params.menuItem.title);
  }

  _getFocused() {
    let content = this.tag('Content');
    return content.children[this.focusIdx];
  }

  _handleDown() {
    let prevValue = this.focusIdx;
    this.focusIdx = Math.min(this.focusIdx + 1, this._getFocusable().length - 1);
    return prevValue !== this.focusIdx;
  }

  _handleUp() {
    let prevValue = this.focusIdx;
    this.focusIdx = Math.max(this.focusIdx - 1, 0);
    return prevValue !== this.focusIdx;
  }

  _getFocusable() {
    return this.tag('Content').children;
  }

  _handleBack() {
    if (this.focusIdx > 0) {
      this.focusIdx = 0;
    } else {
      this.fireAncestors('$focusMenu');
    }
    return true;
  }
}
